import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAutoFlash: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconAutoFlash"><Path d="M20.5 8.5H13.5V1.75L3.5 15.5H10.5V22.25L20.5 8.5Z" stroke="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M23.1016 23.0001L21.4216 14.0001L20.7454 13.9679L15.1016 23.0001H16.3016L17.3483 21.2859H21.7634L22.0816 23.0001H23.1016ZM21.5768 20.2858H17.9742L20.7454 15.8518L21.5768 20.2858Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAutoFlash;
